import { render, staticRenderFns } from "./marketingBirthday.vue?vue&type=template&id=5d806bf0&scoped=true&"
import script from "./marketingBirthday.vue?vue&type=script&lang=js&"
export * from "./marketingBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d806bf0",
  null
  
)

export default component.exports